module.exports = __webpack_public_path__ + "static/media/capital.b1fd8248.jpg";